import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FarmersThankYouRoutingModule } from './farmers-thank-you-routing.module';
import { FarmersThankYouComponent } from './farmers-thank-you.component';

const routes: Routes = [
  {
    path: '',
    component: FarmersThankYouComponent
  }
];

@NgModule({
  declarations: [FarmersThankYouComponent],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
// @NgModule({
//   declarations: [FarmersThankYouComponent],
//   imports: [CommonModule, FarmersThankYouRoutingModule]
// })
export class FarmersThankYouModule {}
